<template>
    <div style="display: flex; align-items: center;" ref="datePickerRef">
        <date-picker v-model="internalModel"
                     :id="datePickerId"
                     :placeholder="placeHolder"
                     :format="format"
                     :aria-labelledby="datePickerLabel"
                     :enable-time-picker="false"
                     :appendToBody="true"
                     :max-date="maxValue"
                     :min-date="minValue"
                     :auto-position="true"
                     :locale="lang"
                     :model-type="modelType"
                     :start-date="startValue"
                     :focus-start-date="true"
                     week-start="0"
                     text-input
                     auto-apply
                     @closed="onCloseFn"
                     arrow-navigation @keydown="(e) => e.keyCode === 32 ? e.stopPropagation() : null" />
        <tippy-ext aria-live="assertive" :tippyTitle="$t('dateField.iadTitle')" :tippyText="$t('dateField.iadText')" />
    </div>
</template>

<script>
    import { ref, watch, computed, onMounted } from 'vue';
    import DatePicker from '@vuepic/vue-datepicker';
    import TippyExt from './TippyExt.vue';

    export default {
        // Define the props that the component accepts
        props: ['modelValue', 'lang', 'placeHolder', 'minValue', 'maxValue', 'startValue', 'datePickerLabel', 'datePickerId'],
        components: {
            DatePicker
        },
        // The setup function is where we define our reactive properties and logic
        setup(props, { emit }) {

            const datePickerRef = ref(null);

            // -- MOUNTED --
            onMounted(() => {
                // Create a callback function to execute when mutations are observed
                var callback = function (mutationsList, observer) {
                    for (let mutation of mutationsList) {
                        if (mutation.type === 'childList') {
                            var inputField = document.querySelector('.dp__input');
                            if (inputField) {
                                inputField.addEventListener('keydown', function (e) {
                                    var calendar = document.querySelector('.dp__outer_menu_wrap');
                                    if (calendar && e.code === 'Tab') {
                                        calendar.setAttribute('id', 'DatePicker');
                                        modalOpen('DatePicker');
                                    }
                                })
                            }
                        }
                    }
                };

                // Create an observer instance linked to the callback function
                var observer = new MutationObserver(callback);

                // Start observing the document with the configured parameters
                observer.observe(document, { childList: true, subtree: true });
            });

            // Function to change focus while closing the date picker modal
            const onCloseFn = () => {
                const element = datePickerRef.value;
                const inputElement = element.getElementsByClassName('dp__input')[0];
                if (inputElement != null) {
                    inputElement.focus();
                }
            }

            // A computed property that returns a different placeholder based on the language prop
            const placeHolder = computed(() => {
                if (props.lang === 'fr') {
                    return 'JJ/MM/AAAA'; // French date format
                }
                else {
                    return 'MM/DD/YYYY'; // Default date format
                }
            });

            // A computed property that returns a different modelType based on the language prop
            const modelType = computed(() => {                
                    return 'MM/dd/yyyy'; // Default date format                
            });

            // A computed property that returns a different format based on the language prop
            const format = computed(() => {
                if (props.lang === 'fr') {
                    return 'dd/MM/yyyy'; // French date format
                }
                else {
                    return 'MM/dd/yyyy'; // Default date format
                }
            });

            // A ref that holds the current value of the modelValue prop
            const internalModel = ref(props.modelValue);

            // Watch for changes in the modelValue prop and update internalModel accordingly
            watch(() => props.modelValue, newVal => {
                internalModel.value = newVal;
            });

            // Watch for changes in internalModel and emit an update:modelValue event with the new value
            watch(internalModel, newVal => {
                emit('update:modelValue', newVal);
            });

            // Return the reactive properties that we want to expose to the template
            return {
                internalModel,
                placeHolder,
                modelType,
                format,
                onCloseFn,
                datePickerRef
            };
        },
    };
</script>
<style>
    .dp__icon,
    .dp__calendar_item,
    .dp__calendar_header_item {
        margin-top: 0px;
    }
</style>